import { render, staticRenderFns } from "./ResultBtns.vue?vue&type=template&id=f37cb1f8&"
import script from "./ResultBtns.vue?vue&type=script&lang=js&"
export * from "./ResultBtns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports